// src/components/Badges.js
export default function Badges({ property: p, size = "sm" }) {
  const fs = size === "sm" ? 10 : 12;
  const py = size === "sm" ? "2px" : "3px";
  const px = size === "sm" ? "7px" : "10px";
  const badge = (bg, color, text) => (
    <span style={{ background: bg, color, fontSize: fs, fontWeight: 700, padding: `${py} ${px}`, borderRadius: 20 }}>
      {text}
    </span>
  );
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
      {p.verified  && badge("#e8f5e9", "#1a6b3c", "✓ Verified")}
      {p.ownerOnly && badge("#fff3e0", "#e65100", "Owner Only")}
      {p.urgent    && badge("#fde8e8", "#c0392b", "🔥 Urgent Sale")}
    </div>
  );
}
